<template>
  <div class="bea-list">
    <div class="list-cell">
      <div
        class="task-mb"
        :style="{
          background: backgroundColor,
          margin: labelPos == 'inline' ? '0' : '0',
        }"
      >
        <div class="cell" :style="{ flexDirection: 'column' }">

              <!-- <a-button @click="$emit('edit', index)" :border="false" style="font-size: 12px;" size="small" shape="round"> <a-icon type="edit"></a-icon> 编辑</a-button> -->
              

          <div class="flex-row" style="width: 100%;">
            <div class="range-level">
              <div v-for="(item, index) in list" :key="index" class="item">
                <div class="student_name">
                  {{ item.name }}
                </div>
                <div v-for="(level, index2) in item.targets" class="level-item" :key="index2">
                  <div class="flex-row">
                    <div class="mubiao">{{ level.field3_name }}</div>
                    <a-button
                        v-if="showAction"
                        @click="handleDel(index, index2)"
                        :border="false"
                        style="font-size: 12px;margin-top: 6px;"
                        size="small"
                        shape="round"
                      >
                        <a-icon type="delete"></a-icon> 删除</a-button
                      >
                  </div>
                  
                  <div class="range" style="margin-top: 3px;">{{ level.field_name + '>' + level.field2_name }}</div>
                  <div class="detail">
                      <div v-for="(target,index3) in level.targets" :key="index3" class="cell">
                          {{ target.name || target.target_name }}
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
    };
  },
  props: {
    labelPos: {
      type: String,
      default: "inline",
    },
    backgroundColor: {
      type: String,
      default: "#f3f4f5",
    },
    showAction: {
      type: Boolean,
      default: true,
    },
    list: {
      type: Array,
      default: () => [],
    },
    range: {
      type: String,
      default: "",
    },
    mubiao: {
      type: String,
      default: "",
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  created() {
  },
  methods: {
    handleDel(index,index2) {
      this.$emit('del',index,index2)
    } 
  },
};
</script>

<style lang="scss" scoped>
.split {
  height: 10px;
  background: #f1f1f1;
}

.student_name {
  background-color: #eaeef3;
  color: #101010;
  padding:4px 6px;
  width: 100%;
  border-radius: 2px;
}
.task-mb {
  width: 100%;
  border-radius: 5px;
  margin: 10px 0;
  .cell {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    margin: 2px 0;

    .flex-row {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: flex-start;
    }

    .range {
      margin-right: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      color: #666;
      font-size: 14px;
      line-height: 1;
      margin-bottom: 8px;
    }

    .mubiao {
      color: #519fd3;
      width: 100%;
      margin-top: 6px;
      font-weight: bold;
      font-size: 14px;
    }

    .range-level {
      flex: 1;
      margin-top: 3px;

      .level-item {
        padding: 5px 0;
        border-bottom: 1px solid #eee;
        &:last-child{
          border-bottom: none;
        }
      }
      .item {
        width: 100%;
        padding: 0px 0 6px 0;
        border-bottom: 1px solid #eee;
        &:last-child{
          margin-bottom: 0;
          border-bottom: none;
        }
        .level {
          display: inline-block;
          padding: 2px 4px;
          border-radius: 8px 2px 8px 2px;
          border: 1px solid #519fd3;
          line-height: 1;
          font-size: 12px;
          color: #519fd3;
          margin-right: 3px;
        }

        .name {
          display: inline-block;
          font-size: 12px;
        }
      }

      .detail {
        font-size: 12px;
      }
    }
  }
}

.task-content {
  .cell {
    display: flex;
    flex-direction: row;
    align-items: center;

    .label {
      margin-right: 6px;
    }
  }
}

.bea-list {
  width: 100%;

  .list-cell {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 10px;
    cursor: pointer;
    &:last-child{
      margin-bottom: 0;
    }

    .avatar {
      width: 36px;
      height: 36px;
      margin-right: 10px;
    }
    .msg {
      flex: 1;
      display: flex;
      flex-direction: column;
      .header {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 14px;
        color: #101010;
        .teacher {
          font-weight: bold;
          font-size: 14px;
        }

        .students {
          font-weight: bold;
        }

        .action {
          margin: 0 6px;
        }

        .info {
          margin-left: 10px;
          font-weight: bold;
        }

        .time {
          margin: 0 10px;
        }

        .status {
          color: #519fd3;
        }
      }

      .content {
        margin-top: 6px;
        color: #6a6a6a;
      }
    }
  }
}

.file {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 10px;
  .item {
    width: 20%;
    display: block;
    padding-bottom: 20%;
    background: #eee;
    overflow: hidden;
    border-radius: 5px;
  }
}

.card {
  padding: 15px;
  .sub-title {
    font-size: 14px;
    font-weight: 500;
    color: #101010;
  }

  .status {
    color: #519fd3;
  }
  .names {
    color: #666;
    margin-top: 4px;
  }
}
</style>
